var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("MMP_HDT_PointCloud", {
        attrs: {
          incomingData: _vm.outgoingData,
          inputtingPCPT: _vm.inputtingPCPT,
        },
        on: {
          cleared: function ($event) {
            return _vm.clearOutgoingData()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "hardDriveTrackingModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal hdt-modal",
            "body-class": "scroll-Container",
            title: "Hard Drive Tracking",
            "hide-footer": "",
            scrollable: "",
          },
          on: {
            show: function ($event) {
              return _vm.loadHardDriveTracking()
            },
          },
        },
        [
          _c(
            "b-container",
            { staticClass: "table-fill-container" },
            [
              _c("MMP_QueryConstructor", {
                attrs: {
                  comp: "HDT",
                  spinner: _vm.queryConstructorSpinner,
                  getConditions: _vm.getConditions,
                  jdayData: [
                    _vm.calculateTodayMinusXJdays(0),
                    _vm.calculateTodayMinusXJdays(7),
                  ],
                },
                on: {
                  applyCustomQuery: function ($event) {
                    return _vm.applyCustomQuery($event)
                  },
                  startSpinner: function ($event) {
                    return _vm.customQueryRunning()
                  },
                },
              }),
              _vm._v(" "),
              !_vm.driveTrackingSpinner
                ? _c("vue-bootstrap4-table", {
                    ref: "vbt_hdt",
                    attrs: {
                      rows: _vm.hardDriveTrackingRows,
                      columns: _vm.hardDriveTrackingColumns,
                      config: _vm.config,
                      actions: _vm.actions,
                      classes: _vm.classes,
                    },
                    on: {
                      "on-select-row": function ($event) {
                        return _vm.rowClicked($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "field_sn",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  class: !props.cell_value ? "vacant-red" : "",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        !props.cell_value
                                          ? "UNLABELED"
                                          : props.cell_value
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "backup",
                          fn: function (props) {
                            return [
                              props.cell_value != null
                                ? _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          props.cell_value ? "Yes" : "No"
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "jday_date",
                          fn: function (props) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    props.row.julian_day != null
                                      ? _vm.getJdayInDateFormat(
                                          props.row.julian_day
                                        )
                                      : ""
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "subcountry",
                          fn: function (props) {
                            return [
                              props.cell_value != null
                                ? _c(
                                    "div",
                                    _vm._l(
                                      props.cell_value,
                                      function (subc, index) {
                                        return _c(
                                          "b-row",
                                          { key: index },
                                          [
                                            _c("b-col", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    index + 1 ==
                                                      props.cell_value.length
                                                      ? subc
                                                      : subc + ", "
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "assigned_user",
                          fn: function (props) {
                            return [
                              _c("div", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      [
                                        "ushr_fieldqc",
                                        "ushr_jenkins",
                                        null,
                                      ].includes(props.cell_value)
                                        ? ""
                                        : props.cell_value
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "collection_type",
                          fn: function (props) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.determineCollectionTypes(props.row)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "start_date",
                          fn: function (props) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    props.cell_value != null
                                      ? new Date(
                                          props.cell_value
                                        ).toLocaleString("en-US", {
                                          dateStyle: "short",
                                        })
                                      : ""
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "complete_date",
                          fn: function (props) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    props.cell_value != null
                                      ? new Date(
                                          props.cell_value
                                        ).toLocaleString("en-US", {
                                          dateStyle: "short",
                                        })
                                      : ""
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "miles",
                          fn: function (props) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    parseFloat(
                                      (
                                        props.row.aerial_miles +
                                        props.row.cm_miles +
                                        props.row.primary_miles +
                                        props.row.ramp_miles +
                                        props.row.secondary_miles +
                                        props.row.tertiary_miles
                                      ).toFixed(2)
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "received",
                          fn: function (props) {
                            return [
                              props.row.received_date != null
                                ? _c("fa", {
                                    attrs: { icon: ["fas", "check"] },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      979699247
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }